import api from '@/api';

const auth_path = '/auth/signin/';
const link_signin_path = '/auth/link_signin/';
const userinfo_path = '/auth/userinfo/';

export default {
  getUserinfo() {
    return new Promise((resolve, reject) => {
      api
      .get(userinfo_path)
      .then(response => resolve(response))
      .catch(error => reject(error));
    })
  },
  postAuth(payload) {
    return new Promise((resolve, reject) => {
      api
        .post(auth_path, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
    })
  },
  /**
   * Вход по ссылке доступа в портал. Возвращает token при успехе.
   * @param {string} slug — slug из URL ссылки доступа.
   * @returns {Promise}
   */
  postLinkSignin(slug) {
    return new Promise((resolve, reject) => {
      api
        .post(link_signin_path, { slug })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
}
